module.exports = __webpack_public_path__ + "static/media/orange-team.acfb6cce.svg";